export const environment = {
    environmentCode: 'DEV',
    environmentName: 'DEV',
    versionNumber: '2026.11.04.7',
    production: false,
    apiUrl: 'https://api-dev.healthcatalyst.net/config/',
    ideaApiUrl: 'https://api-dev.healthcatalyst.net/idea/',
    beaconApiUrl: 'https://apim.healthcatalyst.net/beacon-api/',
    emberApiUrl: 'https://ember-int.healthcatalyst.net',
    samlIdpApiUrl: 'https://ember-dev-cus-actions-service-app-staging.azurewebsites.net',
    appInsightsConnectionString:
        'InstrumentationKey=21c0e5e7-1614-4238-991e-ab0638005881;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/',
    appInsightsServiceDebugLogToConsole: true
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
